<template>
  <div>
    <breadcrumb :routerList="[{to:'/agent/marketingReportTabs',title:'市场推广活动季度报表'},{title:'新增会议'}]"/>
    <div class="bigDiv">
      <div class="h-piece">
        <div>
          <div class="pieceCon n-bu">
            <div class="h-pieceCon2">
              <el-form :model="f" label-position="right" ref="f" :inline="true" :rules="rules"
                       class="demo-ruleForm h-formbLine h-formbLine1">
                <div class="h-rowCon1 marketAdd">
                  <el-form-item label=" 指定经销商" prop="agentName" class="h-elformWrap-2" >
                    <el-select v-model="f.agentCode" remote filterable :filter-method="showComList" clearable
                               placeholder="请输入"
                               :remote-method="showComList" @change="changeComlist">
                      <el-option v-for="(item) in agentList"
                                 :key="item.usercode"
                                 :label="item.customerName1"
                                 :value="item.usercode">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="活动类型" class="h-elformWrap-2" prop="activityType">
                    <el-input placeholder="请输入活动类型" v-model="f.activityType"></el-input>
                  </el-form-item>
                  <el-form-item label="活动名称" class="h-elformWrap-2" prop="activityName">
                    <el-input placeholder="请输入活动名称" v-model="f.activityName"></el-input>
                  </el-form-item>
                  <el-form-item label="活动费用" class="h-elformWrap-2" prop="activityFee">
                    <el-input placeholder="请输入活动费用" v-model="f.activityFee"></el-input>
                  </el-form-item>
                  <el-form-item label="活动时间" class="h-elformWrap-2">
                    <el-date-picker
                        placeholder="请选择"
                        v-model="f.activityTime"
                        :clearable="false"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss" >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="花费门票/成本" class="h-elformWrap-2">
                    <brupload
                        v-model="f.ticketUrl"
                        :refid=meetingId
                        reftype="YX_CostTicket"
                        :showtime="false"
                        uploadflag
                        delflag
                        @filecallback=feeIsUpload>
                    </brupload>
                  </el-form-item>
                  <el-form-item label="签到照片" class="h-elformWrap-2">
                    <brupload
                        v-model="f.ticketUrl"
                        :refid=meetingId
                        reftype="YX_Qiand"
                        :showtime="false"
                        uploadflag
                        delflag
                        @filecallback=feeIsUpload>
                    </brupload>
                  </el-form-item>
                  <el-form-item label="全景照片" class="h-elformWrap-2">
                    <brupload
                        v-model="f.ticketUrl"
                        :refid=meetingId
                        reftype="YX_Quanj"
                        :showtime="false"
                        uploadflag
                        delflag
                        @filecallback=feeIsUpload>
                    </brupload>
                  </el-form-item>
                  <el-form-item label="发布照片" class="h-elformWrap-2">
                    <brupload
                        v-model="f.ticketUrl"
                        :refid=meetingId
                        reftype="YX_Fab"
                        :showtime="false"
                        uploadflag
                        delflag
                        @filecallback=feeIsUpload>
                    </brupload>
                  </el-form-item>
                  <el-form-item label="展示照片" class="h-elformWrap-2">
                    <brupload
                        v-model="f.ticketUrl"
                        :refid=meetingId
                        reftype="YX_Showimg"
                        :showtime="false"
                        uploadflag
                        delflag
                        @filecallback=feeIsUpload>
                    </brupload>
                  </el-form-item>
                  <el-form-item label="交互照片" class="h-elformWrap-2">
                    <brupload
                        v-model="f.ticketUrl"
                        :refid=meetingId
                        reftype="YX_Jiaoh"
                        :showtime="false"
                        uploadflag
                        delflag
                        @filecallback=feeIsUpload>
                    </brupload>
                  </el-form-item>
                  <el-form-item label="体验照片" class="h-elformWrap-2">
                    <brupload
                        v-model="f.ticketUrl"
                        :refid=meetingId
                        reftype="YX_Tiy"
                        :showtime="false"
                        uploadflag
                        delflag
                        @filecallback=feeIsUpload>
                    </brupload>
                  </el-form-item>
                  <el-form-item label="宴请照片" class="h-elformWrap-2">
                    <brupload
                        v-model="f.ticketUrl"
                        :refid=meetingId
                        reftype="YX_Yanq"
                        :showtime="false"
                        uploadflag
                        delflag
                        @filecallback=feeIsUpload>
                    </brupload>
                  </el-form-item>

                </div>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-row style="display: flex;justify-content: center;margin: 30px 0;">
      <el-button class="h-btn h-bBtn h-bgwhite" @click="back">返回</el-button>
<!--      <el-button class="h-btn h-bBtn h-bgblueQ2" @click="zancun()">暂存</el-button>-->
      <el-button class="h-btn h-bBtn h-bgblueQ2" @click="save()">确认提交</el-button>

    </el-row>
  </div>
</template>

<script>

  import ss from "@/api/SystemService";
  import marketingReport from "@/api/loud/agent/marketingReport";

  export default {
    data() {
      return {
        agentList:[],
        rules: {

        },
        f:{
          id:'',
          agentCode:'',
          agentName:'',
          activityName:'',
          activityType:'',
          activityTime:'',
          activityFee:'',
          costTicket:'',
          ticketUrl:[],
        },
        meetingId:null,
      }
    },
    methods:{
      //获取指定经销商
      showComList(value) {
        ss.netApi.selectOnlyName(value).then(res => {
          this.agentList = res.obj
        })
      },
      changeComlist(value){
        this.f.agentCode = value;
        this.f.agentName = this.agentList.find(item => item.usercode == value).customerName1;
      },
      feeIsUpload(v){
        console.log('vvvvvvvv',v)
        this.f.ticketUrl = v.length;
      },
      //返回
      back() {
        this.$router.push({
          path: "/agent/marketingReportTabs",
          query: {
            type: 'second'
          }
        });
      },
      //保存
      save() {
        this.f.id = this.meetingId;
        marketingReport.saveMarketMeeting(this.f).then(res => {
          if(res.f == true){
            this.$message({
              message: '保存成功',
              type: 'success'
            });
            this.back();
          }
        })
      },
    },
    created() {
      this.meetingId = this.$util.getUuid();
    },
  }
</script>

<style scoped>
  .marketAdd .h-elformWrap-2 .el-form-item__label {
    width: 30%;
    text-align: right;
  }
  .marketAdd .h-elformWrap-2 .el-form-item__content {
    width: 70%;
  }
  .marketAdd .h-elformWrap-1 .el-form-item__label {
    width: 8%;
    text-align: right;
  }
  .marketAdd .h-elformWrap-1 .el-form-item__content {
    width: 92%;
  }
  .marketAdd .h-elformWrap-2 {
    width: 33.333% !important;
    padding-right: 0.5rem
  }
  .marketAdd .h-elformWrap-1 {
    width: 100%;
    padding-right: 0.5rem
  }
</style>